import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const fundBenchmarkTypeSelection = {
    name: "Fund Type Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose fund benchmark type",
    defaultConfig: {
        defaultValue: null,
        key: "Fund Benchmark Type",
    },
    type: "input",
    category: "dashboard",
};
